<adapt-filter-content *ngIf="currentOptions"
                      (reset)="resetOptions()"
                      [isDefault]="isDefault"
                      [urlParamNames]="ActivityFilterParamKeys">
    <div class="form-group">
        <label>Activity Type</label>
        <dx-tag-box [items]="CulturalActivityTypeMetadata"
                    [value]="currentOptions.visibleTypes"
                    (valueChange)="onActivityTypesChanged($event)"
                    [showSelectionControls]="true"
                    displayExpr="title"
                    applyValueMode="instantly"
                    tagTemplate="customTag"
                    (onContentReady)="onActivityTypeSelectorReady($event)"
                    data-test="filter-activity-types">
            <div *dxTemplate="let data of 'customTag'">
                <div class="dx-tag-content"
                     [style.background-color]="data.colourAccent">
                    {{data.title ?? data}}
                    <div class="dx-tag-remove-button"></div>
                </div>
            </div>
        </dx-tag-box>
    </div>

    <div class="form-group">
        <label>Status Type</label>
        <div *ngIf="isCalendarView"
             class="small mb-2">This is not supported within the calendar view.</div>
        <dx-tag-box [items]="ActivityStatuses"
                    [value]="currentOptions.visibleStatuses"
                    (valueChange)="onStatusTypesChanged($event)"
                    [showSelectionControls]="true"
                    [disabled]="isCalendarView"
                    displayExpr="text"
                    valueExpr="value"
                    applyValueMode="instantly"
                    data-test="filter-activity-statuses"></dx-tag-box>
    </div>

    <div class="form-group">
        <label>Due Within</label>
        <div *ngIf="isCalendarView"
             class="small mb-2">This is not supported within the calendar view.</div>
        <dx-select-box [dataSource]="DurationOptions"
                       [value]="currentOptions.dueWithin.slug"
                       (valueChange)="onDueWithinDateChanged($event)"
                       displayExpr="text"
                       valueExpr="slug"
                       placeholder="Select timespan..."
                       [showClearButton]="false"
                       [disabled]="isCalendarView"
                       data-test="due-within-options"></dx-select-box>
    </div>
</adapt-filter-content>
